<table
  mat-table
  [dataSource]="items"
  matSort
  [matSortDisabled]="!sort"
  [matSortDisableClear]="true"
  [matSortActive]="sort?.sortBy"
  [matSortDirection]="sort?.sortDirection"
  (matSortChange)="sortChange.emit($event)"
>
  <ng-container matColumnDef="nameDe">
    <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Deutscher Name</th>
    <td mat-cell *matCellDef="let row">
      {{ row.name.de }}
    </td>
  </ng-container>
  <ng-container matColumnDef="nameEn">
    <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Englischer Name</th>
    <td mat-cell *matCellDef="let row">
      {{ row.name.en }}
    </td>
  </ng-container>
  <ng-container matColumnDef="hierarchyName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Zielbaum</th>
    <td mat-cell *matCellDef="let row">{{ row.hierarchyName | localizedString }}</td>
  </ng-container>
  <ng-container matColumnDef="level">
    <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Ebene</th>
    <td mat-cell *matCellDef="let row">{{ row.level }}</td>
  </ng-container>
  <ng-container matColumnDef="accumulatedScore">
    <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>#Verwendet</th>
    <td mat-cell *matCellDef="let row">{{ row.accumulatedScore | number: '1.0-1' }}</td>
  </ng-container>
  <ng-container matColumnDef="tags">
    <th mat-header-cell *matHeaderCellDef i18n>Tags</th>
    <td mat-cell *matCellDef="let row">
      <dt-tag-list
        [tagIds]="row.tags"
        [tagsById]="tagsById"
        [selectedTagIds]="selectedTags"
        (tagClick)="onTagClick($event.id)"
      ></dt-tag-list>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="defaultColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: defaultColumns" (click)="objectiveClick.emit(row)"></tr>

  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" [attr.colspan]="defaultColumns.length" i18n>Keine Ziele entsprechen dem Filter.</td>
  </tr>
</table>
